module.exports = __webpack_public_path__ + "img/profile-1.d629f387.png";